import React from 'react'

import Grid from '@material-ui/core/Grid'
import Data from 'EurestoClass/Data'

import Constants from 'EurestoFonction/Constants'

import Utils from 'EurestoFonction/Utils'

import ViewUpload from '../../Upload/ViewUpload'

export default class Picture extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      avatar: true,
      codeEuresto: this.props.object.code || undefined,
      entite: this.props.object.entite || undefined,
      type: this.props.object.type || 'contact',
      contact_id: this.props.object.id || undefined,
      img: this.props.object.picture.lien || undefined,
      key: Utils.getRandomNumber()
    }
  }

  restate = () => {
    this.setState({
      datas: Data.list(Constants.module.COMMUN, Constants.donnee.pays)
    })
  }

  handleUpload = (val) => {
    this.props.onChange({ id: val.id, media_lien: val.lien }, this.props.name)
    this.setState({
      key: Utils.getRandomNumber(),
      img: val.lien
    })
  }

  render () {
    let templateSend
    if (this.state.entite === 2) {
      templateSend = 'logo'
    } else {
      templateSend = 'photo'
    }
    return (
      <Grid container spacing={0} style={Object.assign({ margin: 0, padding: 0 }, this.props.style || {})} direction="column" justify="center" alignItems="center">
        {this.state.avatar &&
        <ViewUpload avatarStyle={this.props.avatarStyle} disabled={this.props.disabled} key={this.state.key}
                    type={this.state.type}
                    handleUpload={this.handleUpload} contact_id={this.state.contact_id || undefined} view={templateSend}
                    src={this.state.img || undefined}/>
        }

      </Grid>
    )
  }
}




// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/Other/Picture.js